<template>
  <h1 class="font-mono font-bold mt-96 text-indigo-500">{ <span class="text-white">My Projects</span> }</h1>
  <div class="h-full flex flex-wrap items-center justify-center mt-5 gap-5">
    <div id="BGCard" class="Responsive bg-gray-900 rounded-md w-96">
      <header class="grid grid-cols-6 items-center p-3 border-b border-b-indigo-500">
        <div class="">
          <img src="../assets/memoji.png" class="rounded-full w-10 h-10" alt=""/>
        </div>
        <div class="col-span-4 text-sm font-semibold">
          Clone Spotify
        </div>
        <div id="dropdownInformationButton" data-dropdown-toggle="dropdownInformation" data-dropdown-placement="bottom" class="cursor-link hover:cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
          </svg>
        </div>
        <!-- Dropdown menu -->
        <div id="dropdownInformation" class="z-10 hidden divide-y rounded shadow w-44 dark:bg-gray-900 dark:divide-indigo-500">
          <div class="px-4 py-3 text-sm dark:text-white">
            <div>Romain Gaspari & Xavier Coënen</div>
            <div class="font-medium truncate">Spotify</div>
          </div>
          <ul class="py-1 text-sm dark:text-gray-200" aria-labelledby="dropdownInformationButton">
            <div class="py-1">
              <a onclick="goto('http://spotify.rgaspari.fr/Spotify.php')" class="cursor-link dark:hover:cursor-pointer block px-4 py-2 text-sm dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white dark:hover:cursor-pointer">See More</a>
            </div>
          </ul>
        </div>
      </header>
      <photo>
        <img class="h-72 w-full" src="../assets/Spotify.png" alt=""/>
      </photo>
      <content class="flex flex-col p-4 gap-3">
        <div class="flex flex-row gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hearth hover:fill-rose-800 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-600 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-50 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-white h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
          </svg>
        </div>
        <div class="text-sm">
          <span class="cursor-link font-semibold">Le Project</span> consister à crée un lecteur audio, et nous avons décider d'utiliser l'api de la célebre application Spotify.
        </div>
      </content>
      <footer>
      </footer>
    </div>
    <div id="BGCard" class="Responsive bg-gray-900 rounded-md	 w-96">
      <header class="grid grid-cols-6 items-center p-3 border-b border-b-indigo-500">
        <div class="">
          <img src="../assets/memoji.png" class="rounded-full w-10 h-10" alt=""/>
        </div>
        <div class="col-span-4 text-sm font-semibold">
          Weather App
        </div>
        <div id="dropdownTicTacButton" data-dropdown-toggle="dropdownTicTac" data-dropdown-placement="bottom" class="cursor-link hover:cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
          </svg>
        </div>
        <!-- Dropdown menu -->
        <div id="dropdownTicTac" class="z-10 hidden divide-y rounded shadow w-44 dark:bg-gray-900 dark:divide-indigo-500">
          <div class="px-4 py-3 text-sm dark:text-white">
            <div>Romain Gaspari</div>
            <div class="font-medium truncate">App Weather in React</div>
          </div>
          <ul class="py-1 text-sm dark:text-gray-200" aria-labelledby="dropdownInformationButton">
            <div class="py-1">
              <a onclick="goto('http://weatherapp.rgaspari.fr/')" class="cursor-link dark:hover:cursor-pointer block px-4 py-2 text-sm dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white dark:hover:cursor-pointer">See More</a>
            </div>
          </ul>
        </div>
      </header>
      <photo>
        <img class="h-72 w-full" src="../assets/Weather-app.png" alt=""/>
      </photo>
      <content class="flex flex-col p-4 gap-3">
        <div class="flex flex-row gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-rose-800 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-600 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-50 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-linkhover:fill-white h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
          </svg>
        </div>
        <div class="text-sm">
          <span class="font-semibold">MyWeather</span> est une application de méteo sous ReactJS gerer par une api, ce qui nous permet d'afficher la méteo sous 5 jours.
        </div>
      </content>
      <footer>
      </footer>
    </div>
    <div id="BGCard" class="Responsive bg-gray-900 rounded-md	 w-96">
      <header class="grid grid-cols-6 items-center p-3 border-b border-b-indigo-500">
        <div class="">
          <img src="../assets/memoji.png" class="rounded-full w-10 h-10" alt=""/>
        </div>
        <div class="col-span-4 text-sm font-semibold">
          Tour Operator
        </div>
        <div id="dropdownOperatorButton" data-dropdown-toggle="dropdownOperator" data-dropdown-placement="bottom" class="cursor-link hover:cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
          </svg>
        </div>
        <!-- Dropdown menu -->
        <div id="dropdownOperator" class="z-10 hidden divide-y rounded shadow w-44 dark:bg-gray-900 dark:divide-indigo-500">
          <div class="px-4 py-3 text-sm dark:text-white">
            <div class="font-medium">Romain Gaspari & Benjamin Prince</div>
          </div>
          <ul class="py-1 text-sm dark:text-gray-200" aria-labelledby="dropdownInformationButton">
            <div class="py-1">
              <a onclick="goto('https://github.com/WSEngineerRG/Project-TourOperator')" class="cursor-link dark:hover:cursor-pointer block px-4 py-2 text-sm dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white dark:hover:cursor-pointer">Lien Git</a>
            </div>
          </ul>
        </div>
      </header>
      <photo>
        <img class="h-72 w-full" src="../assets/TourOperator.png" alt=""/>
      </photo>
      <content class="flex flex-col p-4 gap-3">
        <div class="flex flex-row gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-rose-800 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-600 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-50 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-white h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
          </svg>
        </div>
        <div class="text-sm">
          <span class="font-semibold">Tour Operator</span> est un site permettant de comparer les vols selon les destinations du plus aux moins lucratifs.
        </div>
      </content>
      <footer>
      </footer>
    </div>
    <div id="BGCard" class="Responsive bg-gray-900 rounded-md	 w-96">
      <header class="grid grid-cols-6 items-center p-3 border-b border-b-indigo-500">
        <div class="">
          <img src="../assets/memoji.png" class="rounded-full w-10 h-10" alt=""/>
        </div>
        <div class="col-span-4 text-sm font-semibold">
          Cagnot'Potes
        </div>
        <div id="dropdownCagnotButton" data-dropdown-toggle="dropdownCagnot" data-dropdown-placement="bottom" class="cursor-link hover:cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" />
          </svg>
        </div>
        <!-- Dropdown menu -->
        <div id="dropdownCagnot" class="z-10 hidden divide-y rounded shadow w-44 dark:bg-gray-900 dark:divide-indigo-500">
          <div class="px-4 py-3 text-sm dark:text-white">
            <div class="font-medium">Romain Gaspari</div>
          </div>
          <ul class="py-1 text-sm dark:text-gray-200" aria-labelledby="dropdownInformationButton">
            <div class="py-1">
              <a onclick="goto('https://github.com/WSEngineerRG/Cagnotes-Potes')" class="cursor-link dark:hover:cursor-pointer block px-4 py-2 text-sm dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white dark:hover:cursor-pointer">Lien Git</a>
            </div>
          </ul>
        </div>
      </header>
      <photo>
        <img class="h-72 w-full" src="../assets/cagnote.png" alt=""/>
      </photo>
      <content class="flex flex-col p-4 gap-3">
        <div class="flex flex-row gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-rose-800 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-600 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-blue-50 h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
          </svg>
          <svg xmlns="http://www.w3.org/2000/svg" class="cursor-link hover:fill-white h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
          </svg>
        </div>
        <div class="text-sm">
          <span class="font-semibold">Cagnot'Potes</span> est une platforme permettant de faire des cagnottes avec un objectif.
        </div>
      </content>
      <footer>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Projects"
}
</script>

<style scoped>

</style>